package com.example.monetix.utils

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import kotlinx.browser.window
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.launch

class JsMediaHandler(
    private val onImageResult: (String?) -> Unit,
    private val onVoiceResult: (String?) -> Unit,
    private val scope: CoroutineScope
) : MediaHandler {

    override fun launchCamera() {
        window.alert("Usa il tasto FOTO per selezionare o scattare una foto dal browser.")
    }

    override fun launchGallery() {
        scope.launch {
            try {
                // Chiama la funzione rimpicciolitrice Base64 creata in ImagePicker.kt
                val base64Image = pickAndCompressImageAsBase64()
                if (base64Image != null) {
                    onImageResult(base64Image)
                }
            } catch (e: Exception) {
                window.alert("Errore nel caricamento immagine.")
            }
        }
    }

    override fun startVoiceRecognition() {
        window.alert("Riconoscimento vocale non disponibile su Web.")
    }
}

@Composable
actual fun rememberMediaHandler(
    onImageResult: (String?) -> Unit,
    onVoiceResult: (String?) -> Unit
): MediaHandler {
    val scope = rememberCoroutineScope()
    return remember(onImageResult, onVoiceResult) {
        JsMediaHandler(onImageResult, onVoiceResult, scope)
    }
}